// removed by extract-text-webpack-plugin
module.exports = {"materialize-textarea":"AccountDropdown__materialize-textarea___3NmxU","modal-2463794813":"AccountDropdown__modal-2463794813___2nG5N","container":"AccountDropdown__container___2t03V","dropdownIcon":"AccountDropdown__dropdownIcon___1hQDW","iconContainer":"AccountDropdown__iconContainer___1NeNp","dropdownContainer":"AccountDropdown__dropdownContainer___ppPLC","menuItem":"AccountDropdown__menuItem___zJlRl","menuButton":"AccountDropdown__menuButton___3LC37"};


//////////////////
// WEBPACK FOOTER
// ./src/components/AccountDropDownReplica/AccountDropdown.scss
// module id = 1460
// module chunks = 0